export const BoxVariableNames = {
  'wst-box-primary-background-color': 'wst-box-primary-background-color',
  'wst-box-primary-border-left-color': 'wst-box-primary-border-left-color',
  'wst-box-primary-border-right-color': 'wst-box-primary-border-right-color',
  'wst-box-primary-border-top-color': 'wst-box-primary-border-top-color',
  'wst-box-primary-border-bottom-color': 'wst-box-primary-border-bottom-color',
  'wst-box-primary-border-left': 'wst-box-primary-border-left',
  'wst-box-primary-border-right': 'wst-box-primary-border-right',
  'wst-box-primary-border-top': 'wst-box-primary-border-top',
  'wst-box-primary-border-bottom': 'wst-box-primary-border-bottom',
  'wst-box-primary-border-top-left-radius': 'wst-box-primary-border-top-left-radius',
  'wst-box-primary-border-top-right-radius': 'wst-box-primary-border-top-right-radius',
  'wst-box-primary-border-bottom-left-radius': 'wst-box-primary-border-bottom-left-radius',
  'wst-box-primary-border-bottom-right-radius': 'wst-box-primary-border-bottom-right-radius',
  'wst-box-secondary-background-color': 'wst-box-secondary-background-color',
  'wst-box-secondary-border-left-color': 'wst-box-secondary-border-left-color',
  'wst-box-secondary-border-right-color': 'wst-box-secondary-border-right-color',
  'wst-box-secondary-border-top-color': 'wst-box-secondary-border-top-color',
  'wst-box-secondary-border-bottom-color': 'wst-box-secondary-border-bottom-color',
  'wst-box-secondary-border-left': 'wst-box-secondary-border-left',
  'wst-box-secondary-border-right': 'wst-box-secondary-border-right',
  'wst-box-secondary-border-top': 'wst-box-secondary-border-top',
  'wst-box-secondary-border-bottom': 'wst-box-secondary-border-bottom',
  'wst-box-secondary-border-top-left-radius': 'wst-box-secondary-border-top-left-radius',
  'wst-box-secondary-border-top-right-radius': 'wst-box-secondary-border-top-right-radius',
  'wst-box-secondary-border-bottom-left-radius': 'wst-box-secondary-border-bottom-left-radius',
  'wst-box-secondary-border-bottom-right-radius': 'wst-box-secondary-border-bottom-right-radius',
  'wst-box-secondary-padding-bottom': 'wst-box-secondary-padding-bottom',
  'wst-box-secondary-padding-top': 'wst-box-secondary-padding-top',
  'wst-box-secondary-padding-left': 'wst-box-secondary-padding-left',
  'wst-box-secondary-padding-right': 'wst-box-secondary-padding-right',
  'wst-box-secondary-box-shadow': 'wst-box-secondary-box-shadow'
};
//# sourceMappingURL=box.js.map